package game.entity

import com.soywiz.kmem.toIntRound
import com.soywiz.korma.geom.Point
import game.Game
import game.Room
import game.TileType

class Projectile(
    private val speed: Double,
    hp: Int = 1,
    damage: Int = 1,
    private val ignoreWall: Boolean = true,
    onDeath: (Enemy) -> Unit = {}
) :
    Enemy(hp, damage, onDeath) {
    private var vecRow = 0.0
    private var vecCol = 0.0
    private var realCol = 0.0
    private var realRow = 0.0

    fun startAttack(game: Game, startCol: Int, startRow: Int, targetCol: Int, targetRow: Int, spriteId: String) {
        sprite = game.getSpriteById(spriteId)

        col = startCol
        row = startRow

        val distance = Point(col, row).distanceTo(targetCol, targetRow)

        vecCol = (targetCol - col.toDouble()) / distance * speed
        vecRow = (targetRow - row.toDouble()) / distance * speed

        realCol = col.toDouble()
        realRow = row.toDouble()
    }

    override fun onTick(game: Game, room: Room) {
        realCol += vecCol
        realRow += vecRow

        col = realCol.toIntRound()
        row = realRow.toIntRound()

        if (offScreen() || (!ignoreWall && room[col, row].type == TileType.Wall)) {
            onDeath.invoke(this)
            room.removeEntity(this)
        }
    }
}